import {
  Dialog,
  DialogContent,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { maybe, renderCollection, splitDateTime } from "@saleor/misc";
import { BulkOperationProductsEvent } from "@saleor/products/types/BulkOperationProductsEvent";
import React from "react";
import { FormattedMessage } from "react-intl";

export interface EventDialogProps {
  data: BulkOperationProductsEvent;
  open: boolean;
  onClose: () => void;
}

// id: string;
// startTime: any;
// endTime: any | null;
// message: string | null;
// localFile: string;
// operationUser: string;

const EventDialog: React.FC<EventDialogProps> = ({ data, open, onClose }) => (
  <>
    <Dialog onClose={onClose} open={open} fullWidth maxWidth="md">
      <DialogTitle>
        <FormattedMessage defaultMessage="Bulk Created Product Event" />
      </DialogTitle>
      <DialogContent style={{ overflowY: "scroll", height: "550px" }}>
        <TableHead>
          <TableCellHeader style={{ width: "240px" }}>
            <FormattedMessage defaultMessage="Upload Date" />
          </TableCellHeader>
          <TableCellHeader style={{ width: "240px" }}>
            <FormattedMessage defaultMessage="File" />
          </TableCellHeader>
          <TableCellHeader style={{ width: "240px" }}>
            <FormattedMessage defaultMessage="Message" />
          </TableCellHeader>
          <TableCellHeader style={{ width: "240px" }}>
            <FormattedMessage defaultMessage="User" />
          </TableCellHeader>
        </TableHead>
        <TableBody>
          {renderCollection(data?.bulkOperationProductsEvent, item => (
            <TableRow key={item ? item.id : "skeleton"}>
              <TableCell>
                {item && item.startTime ? (
                  splitDateTime(maybe(() => item.startTime, "")).date +
                  " " +
                  splitDateTime(maybe(() => item.startTime, "")).time
                ) : item && item.startTime === null ? (
                  "-"
                ) : (
                  <Skeleton />
                )}
              </TableCell>
              <TableCell>{item ? item.localFile : <Skeleton />}</TableCell>
              <TableCell>{item ? item.message : <Skeleton />}</TableCell>
              <TableCell>{item ? item.operationUser : <Skeleton />}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </DialogContent>
    </Dialog>
  </>
);

export default EventDialog;
